function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.46201 10.1898C3.46201 11.12 2.711 11.8718 1.78179 11.8718C0.852572 11.8718 0.101562 11.12 0.101562 10.1898C0.101562 9.2596 0.852572 8.50781 1.78179 8.50781H3.46201V10.1898ZM4.30212 10.1898C4.30212 9.2596 5.05313 8.50781 5.98235 8.50781C6.91156 8.50781 7.66257 9.2596 7.66257 10.1898V14.3947C7.66257 15.3249 6.91156 16.0767 5.98235 16.0767C5.05313 16.0767 4.30212 15.3249 4.30212 14.3947V10.1898Z",
    fill: "#E01E5A",
    style: {
      fill: "#E01E5A",
      fill: "color(display-p3 0.8784 0.1176 0.3529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9814 3.44208C5.05219 3.44208 4.30118 2.69029 4.30118 1.7601C4.30118 0.829918 5.05219 0.078125 5.9814 0.078125C6.91062 0.078125 7.66163 0.829918 7.66163 1.7601V3.44208H5.9814ZM5.9814 4.29581C6.91062 4.29581 7.66163 5.0476 7.66163 5.97779C7.66163 6.90797 6.91062 7.65976 5.9814 7.65976H1.76811C0.8389 7.65976 0.0878906 6.90797 0.0878906 5.97779C0.0878906 5.0476 0.8389 4.29581 1.76811 4.29581H5.9814Z",
    fill: "#36C5F0",
    style: {
      fill: "#36C5F0",
      fill: "color(display-p3 0.2118 0.7725 0.9412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7142 5.97779C12.7142 5.0476 13.4652 4.29581 14.3945 4.29581C15.3237 4.29581 16.0747 5.0476 16.0747 5.97779C16.0747 6.90797 15.3237 7.65976 14.3945 7.65976H12.7142V5.97779ZM11.8741 5.97779C11.8741 6.90797 11.1231 7.65976 10.1939 7.65976C9.26468 7.65976 8.51367 6.90797 8.51367 5.97779V1.7601C8.51367 0.829918 9.26468 0.078125 10.1939 0.078125C11.1231 0.078125 11.8741 0.829918 11.8741 1.7601V5.97779Z",
    fill: "#2EB67D",
    style: {
      fill: "#2EB67D",
      fill: "color(display-p3 0.1804 0.7137 0.4902)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1939 12.7128C11.1231 12.7128 11.8741 13.4645 11.8741 14.3947C11.8741 15.3249 11.1231 16.0767 10.1939 16.0767C9.26468 16.0767 8.51367 15.3249 8.51367 14.3947V12.7128H10.1939ZM10.1939 11.8718C9.26468 11.8718 8.51367 11.12 8.51367 10.1898C8.51367 9.2596 9.26468 8.50781 10.1939 8.50781H14.4072C15.3364 8.50781 16.0874 9.2596 16.0874 10.1898C16.0874 11.12 15.3364 11.8718 14.4072 11.8718H10.1939Z",
    fill: "#ECB22E",
    style: {
      fill: "#ECB22E",
      fill: "color(display-p3 0.9255 0.6980 0.1804)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.d049d8c79e250350356a08f82c831e99.svg";
export { ForwardRef as ReactComponent };